import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class UserGroupsIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <>
                <path fill={color}
                      d="M3.84,10.41a6,6,0,0,0,1.35-.7c-.17-.08-.38-.19-.61-.28-.77-.29-1-.55-1-1.08,0-.32.24-.22.34-.81,0-.24.24,0,.28-.56,0-.22-.11-.27-.11-.27s.06-.33.08-.58A1.09,1.09,0,0,0,2.93,5,1.09,1.09,0,0,0,1.7,6.13c0,.25.08.57.08.57s-.12.06-.12.28c0,.56.25.32.29.56.1.59.34.48.34.8,0,.54-.26.79-1,1.08S0,10,0,10.23V11H2.59A5.35,5.35,0,0,1,3.84,10.41Z"/>
                <path fill={color}
                      d="M10.83,11.18c-1.31-.55-1.73-1-1.73-2,0-.6.4-.4.58-1.49.07-.45.42,0,.5-1,0-.41-.2-.52-.2-.52s.1-.6.14-1.07A2,2,0,0,0,8,3,2,2,0,0,0,5.89,5.08c0,.47.13,1.07.13,1.07s-.19.1-.19.51c.07,1,.42.59.5,1,.17,1.08.57.89.57,1.49,0,1-.42,1.44-1.73,2S3,12.28,3,12.67V14H13V12.67C13,12.28,12.14,11.72,10.83,11.18Z"/>
                <path fill={color}
                      d="M14.77,9.42c-.73-.29-1-.54-1-1.08,0-.32.22-.21.32-.8,0-.24.24,0,.28-.56,0-.22-.11-.27-.11-.27s.05-.33.07-.58A1.07,1.07,0,0,0,13.18,5,1.09,1.09,0,0,0,12,6.13c0,.25.08.58.08.58S12,6.76,12,7c0,.56.24.32.28.56.1.59.32.48.32.8,0,.54-.24.79-1,1.08-.22.09-.42.18-.59.27a5.72,5.72,0,0,0,1.3.72,5.39,5.39,0,0,1,1.23.59H16v-.78C16,10,15.51,9.71,14.77,9.42Z"/>
            </>
        ]
    }
    getViewBox = () => '0 0 16 16'
}
